export const ApproveStateEnum = {
  /**全部 null */
  all: null,
  /**草稿中 N */
  draft: "N",
  /**已通过 Y */
  pass: "Y",
  /**已驳回 R */
  reject: "R",
  /**已撤销 C*/
  cancel: "C",
  /**审批中 A */
  approval: "A",
  /**已废弃 */
  discarded: "D",
};

export const ApproveStateOption = [
  { label: "全部", value: ApproveStateEnum.all },
  { label: "草稿中", value: ApproveStateEnum.draft },
  { label: "审批中", value: ApproveStateEnum.approval },
  { label: "已通过", value: ApproveStateEnum.pass },
  { label: "已驳回", value: ApproveStateEnum.reject },
  { label: "已撤销", value: ApproveStateEnum.cancel },
  { label: "已废弃", value: ApproveStateEnum.discarded },
];

export const SelectItemsValue = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const SelectQuestionType = ["单选题", "多选题"];
